/**
 * Local Console Adapter
 * Formata os logs com emojis e clareza para facilitar o desenvolvimento.
 */

const EMOJIS = {
  DEBUG: '🐛',
  INFO: 'ℹ️',
  WARN: '⚠️',
  ERROR: '🚨',
  TRANSACTION: '💸',
};

const consoleAdapter = {
  name: 'ConsoleAdapter',
  log: (payload) => {
    const { timestamp, level, message, data } = payload;
    const emoji = EMOJIS[level] || '📝';
    
    // Simplificamos o formato de hora para ser mais amigável a leitura humana
    const timeCode = new Date(timestamp).toLocaleTimeString();
    
    let consoleTarget = console.log;
    if (level === 'WARN') consoleTarget = console.warn;
    if (level === 'ERROR') consoleTarget = console.error;

    if (data) {
      consoleTarget(`[${timeCode}] ${emoji} [${level}] ${message}`, '\n', data);
    } else {
      consoleTarget(`[${timeCode}] ${emoji} [${level}] ${message}`);
    }
  }
};

export default consoleAdapter;
